import { render, staticRenderFns } from "./Awarding.vue?vue&type=template&id=09e2d826&scoped=true&"
import script from "./Awarding.vue?vue&type=script&lang=js&"
export * from "./Awarding.vue?vue&type=script&lang=js&"
import style0 from "./Awarding.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Awarding.vue?vue&type=style&index=1&id=09e2d826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2d826",
  null
  
)

export default component.exports